import {
  DateBox,
  List,
  SelectBox,
  CheckBox,
  Template,
  DropDownBox,
} from "devextreme-react";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import moment from "moment";
import { getRequestParams } from "../../helpers/globalfunctions";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { DateFormat } from "../../helpers/fixcodes";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { RegEx } from "../../helpers/fixcodes";
import { axiosGet, axiosPost } from "../../apis/useAxios";
import DataSource from "devextreme/data/data_source.js";
import { DataGridSkeletonPageSimpleWithTitle } from "../skeleton/GridSkeleton";
import { askConfirmation, showResponseMessage } from "../../helpers/message";

const DutyTypeLst = [
  { id: 0, name: "All Duty" },
  { id: 1, name: "Fly" },
  { id: 2, name: "Non Fly" },
];

export default function CrewActivityComponent() {
  const [state, setState] = useState({
    isFilterSubmitted: false,
    isActivityApiLoading: false,
    isSubmitted: false,
    filterDropdownEmployeeDataSource: [],
    filterEmployeeNumber: "",
    filterDropdownAirportDataSource: [],
    filterAirportCode: "",
    filterDropdownHotelDataSource: [],
    filterHotelId: 0,
    filterHotelApiLoading: true,
    filterFromDatetime: new Date(moment().startOf("day")),
    filterToDatetime: new Date(moment().endOf("day")),
    crewActivityLst: [],
    crewActivityGridDataSource: [],
    openCancelHotelStayPopup: false,
    activityData: null,
    dutyTypeId: 2,
    openChangeHotelPopup: false,
  });
  const refDataGrid = useRef();
  const refLstEmployees = useRef(null);
  useLayoutEffect(() => {
    document.querySelector("#lblPageTitle").innerHTML = `Crew Activity`;
  });
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnLoad = async () => {
    try {
      setTimeout(async () => {
        await GetfilterDropdownAirport();
      }, 0);
      setTimeout(async () => {
        await GetfilterDropdownEmployee();
      }, 0);
      setTimeout(async () => {
        await GetfilterDropdownHotel("");
      }, 0);

      setTimeout(async () => {
        setState((prev) => ({
          ...prev,
          isActivityApiLoading: true,
        }));
        await getCrewActivitys();
        setState((prev) => ({
          ...prev,
          isActivityApiLoading: false,
        }));
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  const GetfilterDropdownAirport = async () => {
    try {
      let url = `${
        process.env.REACT_APP_API_BASE_URL
      }Airport/get-airport-dropdown/${sessionStorage.getItem(
        "session_airlineCode"
      )}`;
      const res = await fetch(url, getRequestParams("GET")).then((response) =>
        response.json()
      );
      setState((prev) => ({
        ...prev,
        filterDropdownAirportDataSource: res.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const GetfilterDropdownEmployee = async () => {
    try {
      const res = await axiosGet(`/Crew/get-crew-dropdown`, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
      });
      setState((prev) => ({
        ...prev,
        filterDropdownEmployeeDataSource: res?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const GetfilterDropdownHotel = async (airportCode) => {
    try {
      setState((prev) => ({
        ...prev,
        filterHotelApiLoading: true,
      }));
      const response = await axiosGet(`/Hotel/get-hotel-dropdown`, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
        AirportCode: airportCode,
      });
      setState((prev) => ({
        ...prev,
        filterDropdownHotelDataSource: response?.payload ?? [],
        filterHotelApiLoading: false,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({
        ...prev,
        filterHotelApiLoading: false,
      }));
    }
  };
  const handleOnFilterGridDataSource = async () => {
    try {
      setState((prev) => ({
        ...prev,
        isFilterSubmitted: true,
        isActivityApiLoading: true,
      }));
      await getCrewActivitys();
      setState((prev) => ({
        ...prev,
        isFilterSubmitted: false,
        isActivityApiLoading: false,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const getCrewActivitys = async () => {
    try {
      var request = {};
      let filterFromDatetime = moment(state.filterFromDatetime).startOf("day");
      let filterToDatetime = moment(state.filterToDatetime).endOf("day");
      request.AirlineCode = sessionStorage.getItem("session_airlineCode");
      request.EmployeeNumber = state.filterEmployeeNumber;
      request.AirportCode = state.filterAirportCode;
      request.HotelId = state.filterHotelId;
      request.ActivateStartDate =
        moment(filterFromDatetime).format(`YYYY-MM-DD HH:mm:ss`);
      request.ActivateEndDate =
        moment(filterToDatetime).format(`YYYY-MM-DD HH:mm:ss`);
      setState((prev) => ({
        ...prev,
        filterFromDatetime: filterFromDatetime,
        filterToDatetime: filterToDatetime,
      }));
      let res = await fetch(
        process.env.REACT_APP_API_BASE_URL + "CrewActivity/schedule-list",
        getRequestParams("POST", request)
      ).then((response) => response.json());
      let crewActivityLst = res.payload ?? [];
      setState((prev) => ({
        ...prev,
        crewActivityLst: crewActivityLst,
      }));
      filterActivityDataGridDutyTypeWise(state.dutyTypeId, crewActivityLst);
    } catch (error) {
      console.log(error);
    }
  };
  const filterActivityDataGridDutyTypeWise = (dutyTypeId, crewActivityLst) => {
    try {
      let crewActivityGridDataSource = [
        ...new Set(
          crewActivityLst?.filter(
            (f) =>
              dutyTypeId === 0 ||
              (dutyTypeId === 1 &&
                (f.activityTypeId === 0 || f.activityTypeId === 1)) ||
              (dutyTypeId === 2 && f.activityTypeId === 2)
          )
        ),
      ];
      setState((prev) => ({
        ...prev,
        crewActivityGridDataSource: crewActivityGridDataSource,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="filter-box">
        <div className="card p-2 m-0">
          <div className="row">
            <div className="col-lg-2 col-md-2">
              <div className="form-group">
                <label>Employee Number</label>
                {/* <SelectBox
                  dataSource={state.filterDropdownEmployeeDataSource}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Employee"
                  value={state.filterEmployeeNumber}
                  valueExpr="employeeNumber"
                  displayExpr="employeeName"
                  showClearButton={true}
                  searchEnabled={true}
                  onValueChanged={(e) => {
                    setState((prev) => ({
                      ...prev,
                      filterEmployeeNumber: e.value ?? "",
                    }));
                  }}
                /> */}
                <DropDownBox
                  value={state.filterEmployeeNumber}
                  valueExpr="employeeNumber"
                  displayExpr="employeeName"
                  deferRendering={false}
                  showClearButton={true}
                  dataSource={state.filterDropdownEmployeeDataSource}
                  onValueChanged={() => {
                    refLstEmployees.current.instance.unselectAll();
                    setState((prev) => ({
                      ...prev,
                      filterEmployeeNumber: "",
                    }));
                  }}
                  contentRender={() => {
                    return (
                      <List
                        ref={refLstEmployees}
                        //dataSource={state.filterDropdownEmployeeDataSource}
                        dataSource={
                          new DataSource({
                            store: state.filterDropdownEmployeeDataSource,
                            // sort: [
                            //   "Position",
                            //   { selector: "employeeName", desc: true },
                            // ],
                            sort: "employeeName",
                            sortOrder: "asc",
                            paginate: true,
                            pageSize: 10,
                          })
                        }
                        height={400}
                        keyExpr="employeeNumber"
                        displayExpr="employeeName"
                        searchEnabled={true}
                        searchExpr={["employeeNumber", "employeeName"]}
                        searchMode="contains"
                        pageLoadMode="scrollBottom"
                        showSelectionControls={true}
                        selectionMode={"single"}
                        indicateLoading={true}
                        selectByClick={true}
                        // onItemClick={(item) => {
                        //   try {
                        //     setState((prev) => ({
                        //       ...prev,
                        //       filterEmployeeNumber:
                        //         item?.itemData?.employeeNumber ?? "",
                        //     }));
                        //   } catch (error) {
                        //     console.log("List.onItemClick", error);
                        //   }
                        // }}
                        onSelectionChanged={() => {
                          try {
                            let filterEmployeeNumber =
                              state.filterEmployeeNumber;
                            if (refLstEmployees.current) {
                              filterEmployeeNumber =
                                refLstEmployees.current.instance.option()
                                  .selectedItemKeys[0] ?? "";
                            }
                            setState((prev) => ({
                              ...prev,
                              filterEmployeeNumber: filterEmployeeNumber,
                            }));
                          } catch (error) {
                            console.log("onSelectionChanged", error);
                          }
                        }}
                      />
                    );
                  }}
                  placeholder="Select Employee"
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-2">
              <div className="form-group">
                <label>Airport</label>
                <SelectBox
                  dataSource={state.filterDropdownAirportDataSource}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Airport"
                  value={state.filterAirportCode}
                  displayExpr="airportName"
                  valueExpr="airportCode"
                  showClearButton={true}
                  searchEnabled={true}
                  onValueChanged={async (e) => {
                    let filterAirportCode = e.value ?? "";
                    setState((prev) => ({
                      ...prev,
                      filterAirportCode: filterAirportCode,
                      filterHotelId: 0,
                    }));
                    await GetfilterDropdownHotel(filterAirportCode);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-2">
              <div className="form-group">
                <label>Hotel</label>
                <SelectBox
                  dataSource={state.filterDropdownHotelDataSource}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Hotel"
                  defaultValue={state.filterHotelId}
                  displayExpr="hotelName"
                  valueExpr="hotelId"
                  showClearButton={true}
                  searchEnabled={true}
                  onValueChanged={(e) => {
                    setState((prev) => ({
                      ...prev,
                      filterHotelId: e.value ?? 0,
                    }));
                  }}
                />
                {state.filterHotelApiLoading && (
                  <i
                    className="fas fa-spinner fa-spin text-green"
                    style={{
                      float: "right",
                      marginTop: "-22px",
                      marginRight: "12px",
                    }}
                  />
                )}
              </div>
            </div>
            <div className="col-lg-2 col-md-2">
              <div className="form-group">
                <label>From Time (Check-in)</label>
                <DateBox
                  type="date"
                  className="replay-date-time"
                  placeholder="dd/MM/yyyy"
                  displayFormat="dd/MM/yyyy"
                  width="100%"
                  showAnalogClock={true}
                  useMaskBehavior={true}
                  defaultValue={state.filterFromDatetime}
                  value={state.filterFromDatetime}
                  acceptCustomValue={false}
                  onValueChanged={(date) => {
                    setState((prev) => ({
                      ...prev,
                      filterFromDatetime: moment(new Date(date.value)).startOf(
                        "days"
                      ),
                      filterToDatetime: moment(new Date(date.value)).endOf(
                        "days"
                      ),
                    }));
                  }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-2">
              <div className="form-group">
                <label>To Time (Check-in)</label>
                <DateBox
                  type="date"
                  className="replay-date-time"
                  placeholder="dd/MM/yyyy"
                  displayFormat="dd/MM/yyyy"
                  width="100%"
                  min={state.filterFromDatetime}
                  showAnalogClock={true}
                  useMaskBehavior={true}
                  defaultValue={state.filterToDatetime}
                  value={state.filterToDatetime}
                  acceptCustomValue={false}
                  onValueChanged={(date) => {
                    let filterFromDatetime = state.filterFromDatetime;
                    if (
                      moment(filterFromDatetime).isAfter(moment(date.value))
                    ) {
                      filterFromDatetime = date.value;
                    }
                    setState((prev) => ({
                      ...prev,
                      filterFromDatetime: filterFromDatetime,
                      filterToDatetime: date.value,
                    }));
                  }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-2">
              <div className="form-group has-feedback">
                <div>
                  <br />
                </div>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={async () => {
                    await handleOnFilterGridDataSource();
                  }}
                >
                  <span title="Search">
                    <i
                      className={`fas fa-${
                        state.isFilterSubmitted ? "spinner fa-spin" : "filter"
                      }`}
                    ></i>
                    &nbsp;Search
                  </span>
                </button>
                &nbsp; &nbsp;
                <button
                  type="button"
                  className="btn btn-custom-gray"
                  onClick={() => {
                    setState((prev) => ({
                      ...prev,
                      filterEmployeeNumber: "",
                      filterAirportCode: "",
                      filterHotelId: 0,
                      filterFromDatetime: new Date(moment().startOf("day")),
                      filterToDatetime: new Date(moment().endOf("day")),
                    }));
                  }}
                >
                  <span title="Clear">
                    <i className="fas fa-eraser"></i> Clear
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* datagrid */}
      <div className="card">
        <div className="card-body">
          <div>
            {state.isActivityApiLoading && (
              <DataGridSkeletonPageSimpleWithTitle />
            )}
            {!state.isActivityApiLoading && (
              <DataGrid
                ref={refDataGrid}
                dataSource={state.crewActivityGridDataSource}
                // dataSource={
                //   new DataSource({
                //     store: state.crewActivityGridDataSource?.filter(
                //       (f) =>
                //         state.dutyTypeId === 0 ||
                //         (state.dutyTypeId === 1 &&
                //           (f.activityTypeId === 0 || f.activityTypeId === 1)) ||
                //         (state.dutyTypeId === 2 && f.activityTypeId === 2)
                //     ),
                //   })
                // }
                columnAutoWidth={true}
                showColumnLines={true}
                showRowLines={true}
                showBorders={true}
                rowAlternationEnabled={false}
                allowColumnResizing={true}
                onCellPrepared={(e) => {
                  if (e.rowType === "header") {
                    e.cellElement.style.backgroundColor = "#f0f2f5";
                  }
                  if (e.rowType === "data") {
                    if (e.column.dataField === "id") {
                      e.cellElement.style.backgroundColor = "#f0f2f5";
                    }
                    if (e.column.dataField !== "id") {
                      if (e.data.activityTypeId === 1) {
                        e.cellElement.style.backgroundColor = "#ffffff";
                      }
                      if (e.data.activityTypeId === 2) {
                        e.cellElement.style.backgroundColor = "#f2f2f2";
                      }
                    }
                  }
                }}
                onToolbarPreparing={(e) => {
                  e.toolbarOptions.items.unshift(
                    {
                      location: "before",
                      template: "toolbarDataFilterTemplate",
                    },
                    {
                      location: "before",
                      template: "toolbarDataDutyTypeDropdownTemplate",
                    },
                    {
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        onClick: async (e) => {
                          try {
                            refDataGrid.current.instance.beginCustomLoading();
                            e.component.option(
                              "icon",
                              "fas fa-spinner fa-spin"
                            );
                            await new Promise((resolve) =>
                              setTimeout(resolve, 500)
                            ); // 0.5 sec
                            await getCrewActivitys();
                            refDataGrid.current.instance.endCustomLoading();
                            e.component.option("icon", "refresh");
                          } catch (error) {
                            console.log(error);
                          }
                        },
                      },
                    }
                  );
                }}
              >
                {/* <Column
                  dataField="id"
                  caption=""
                  allowSorting={false}
                  allowSearch={false}
                  allowExporting={false}
                  allowFiltering={false}
                  cellRender={(data) => {
                    let updateLink = (data.data.tripTypeId === 1 ||
                      data.data.tripTypeId === 2 ||
                      data.data.tripTypeId === 9 ||
                      data.data.tripTypeId === 10 ||
                      data.data.tripTypeId === 15 ||
                      data.data.tripTypeId === 16) && (
                      <a
                        href="#"
                        title="Cancel Hotel Stay"
                        onClick={(e) => {
                          e.preventDefault();
                          setState((prev) => ({
                            ...prev,
                            openCancelHotelStayPopup: true,
                            activityData: data?.data,
                          }));
                        }}
                        className="btn-link"
                      >
                        <i
                          style={{
                            cursor: "pointer",
                            textAlign: "center",
                            margin: "0px",
                          }}
                          className="fas fa-home"
                        ></i>
                      </a>
                    );
                    let changeHotelLink = (
                      <a
                        href="#"
                        title="Change Hotel"
                        onClick={(e) => {
                          e.preventDefault();
                          setState((prev) => ({
                            ...prev,
                            openChangeHotelPopup: true,
                            activityData: data?.data,
                          }));
                        }}
                        className="btn-link"
                      >
                        <i
                          style={{
                            cursor: "pointer",
                            marginLeft: `${updateLink ? "8px" : "0px"}`,
                          }}
                          className="fas fa-hotel"
                        ></i>
                      </a>
                    );
                    return (
                      <div style={{ textAlign: "left" }}>
                        {updateLink}
                        {changeHotelLink}
                      </div>
                    );
                  }}
                  fixed={true}
                  width={50}
                  visible={true}
                /> */}
                <Column
                  dataField="activityType"
                  caption="Duty Type"
                  allowSearch={true}
                />
                <Column
                  dataField="transactionId"
                  caption="Transaction Id"
                  allowSearch={true}
                />
                <Column
                  dataField="activityDisplay"
                  caption="Activity"
                  allowSearch={true}
                />
                <Column
                  dataField="flightTime"
                  caption="Flight Time"
                  allowSearch={true}
                  format={DateFormat.DisplayDateTime24NorthFormat}
                  dataType="datetime"
                />
                <Column
                  dataField="activityStartTime"
                  caption="Activity Start Time"
                  allowSearch={true}
                  format={DateFormat.DisplayDateTime24NorthFormat}
                  dataType="datetime"
                />
                <Column
                  dataField="activityEndTime"
                  caption="Activity End Time"
                  allowSearch={true}
                  format={DateFormat.DisplayDateTime24NorthFormat}
                  dataType="datetime"
                />
                <Column
                  dataField="employeeNumber"
                  caption="Employee #"
                  allowSearch={true}
                />
                <Column
                  dataField="fullName"
                  caption="Crew Name"
                  allowSearch={true}
                />
                <Column dataField="rank" caption="Rank" allowSearch={true} />
                <Column
                  dataField="airportCode"
                  caption="Airport"
                  allowSearch={true}
                />
                <Column
                  dataField="crewBaseStation"
                  caption="Base Station"
                  allowSearch={true}
                />
                <Column
                  dataField="transportationCompany"
                  caption="Transporter"
                  allowSearch={true}
                />
                <Column
                  dataField="pickupLocation"
                  caption="Pickup"
                  allowSearch={true}
                  width={200}
                />
                <Column
                  dataField="dropOffLocation"
                  caption="Dropoff"
                  allowSearch={true}
                  width={200}
                />
                <Column
                  dataField="dutyReportingTime"
                  caption="Reporting Time"
                  allowSearch={true}
                  format={DateFormat.DisplayDateTime24NorthFormat}
                  dataType="datetime"
                />
                <Column
                  dataField="deBriefingTime"
                  caption="DeBriefing Time"
                  allowSearch={true}
                  format={DateFormat.DisplayDateTime24NorthFormat}
                  dataType="datetime"
                />
                <Column
                  dataField="pickupTime"
                  caption="Pickup Time"
                  allowSearch={true}
                  format={DateFormat.DisplayDateTime24NorthFormat}
                  dataType="datetime"
                />
                <Column
                  dataField="dropoffTime"
                  caption="Dropoff Time"
                  allowSearch={true}
                  format={DateFormat.DisplayDateTime24NorthFormat}
                  dataType="datetime"
                />

                <Column
                  dataField="flightNumber"
                  caption="Flight #"
                  allowSearch={true}
                />
                <Column
                  dataField="activityLocationCode"
                  caption="Activity Location Code"
                  allowSearch={true}
                />
                <Template
                  name="toolbarDataFilterTemplate"
                  render={() => {
                    return (
                      <>
                        <span>
                          <i className={`fas fa-clock`}></i> Crew Activity
                          <span className="ml-2">
                            [{" "}
                            {moment(state.filterFromDatetime).format(
                              `DD/MM/yyyy HH:mm`
                            )}
                            {" - "}
                            {moment(state.filterToDatetime).format(
                              `DD/MM/yyyy HH:mm`
                            )}{" "}
                            ]
                          </span>
                        </span>
                      </>
                    );
                  }}
                />
                <Template
                  name="toolbarDataDutyTypeDropdownTemplate"
                  render={() => {
                    return (
                      <>
                        <SelectBox
                          dataSource={DutyTypeLst}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Select duty type"
                          name="dutyTypeDropdown"
                          defaultValue={0}
                          value={state.dutyTypeId}
                          displayExpr="name"
                          valueExpr="id"
                          onValueChanged={(e) => {
                            let dutyTypeId = e.value ?? 0;
                            try {
                              setState((prev) => ({
                                ...prev,
                                dutyTypeId: dutyTypeId,
                              }));
                              filterActivityDataGridDutyTypeWise(
                                dutyTypeId,
                                state.crewActivityLst
                              );
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          showClearButton={true}
                          searchEnabled={true}
                        />
                      </>
                    );
                  }}
                />
                <HeaderFilter visible={true} />
                <Paging defaultPageSize={20} />
                <Pager
                  showPageSizeSelector={true}
                  allowedPageSizes={[10, 20, 50]}
                  showInfo={true}
                  visible={true}
                />
                <SearchPanel
                  visible={true}
                  highlightCaseSensitive={true}
                  width={240}
                  placeholder="Search..."
                />
                <Export
                  enabled={true}
                  allowExportSelectedData={false}
                  fileName="CrewActivity"
                />
              </DataGrid>
            )}
          </div>
        </div>
      </div>
      {state.openCancelHotelStayPopup && (
        <ChangeCancelHotelModal
          airlineCode={state.activityData.airlineCode}
          employeeNumber={state.activityData.employeeNumber}
          airportCode={state.activityData.airportCode}
          reservationId={state.activityData.reservationId}
          hotelName={
            state.activityData.tripTypeId === 1 ||
            state.activityData.tripTypeId === 9 ||
            state.activityData.tripTypeId === 15
              ? state.activityData.hotelName
              : state.activityData.dropOffHotelName
          }
          isHotelCancel={true}
          isTransporterRequired={true}
          onRefresh={async () => await getCrewActivitys()}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openCancelHotelStayPopup: false,
              airlineCode: "",
              activityData: null,
            }));
          }}
        />
      )}
      {state.openChangeHotelPopup && (
        <ChangeHotelModal
          activityData={state.activityData}
          onRefresh={async () => {
            await getCrewActivitys();
          }}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openChangeHotelPopup: false,
              activityData: null,
            }));
          }}
        />
      )}
    </>
  );
}

function ChangeCancelHotelModal(props) {
  const [state, setState] = useState({
    dropdownAirportDataSource: [],
    airlineCode: props.airlineCode,
    employeeNumber: props.employeeNumber,
    airportCode: props.airportCode,
    reservationId: props.reservationId,
    isHotelCancel: props.isHotelCancel,
    isTransporterRequired: props.isTransporterRequired,
    isOpenSelectAddressModal: false,
    crewAdderssDropdownDataSource: [],
    latitude: "",
    longitude: "",
    addressId: 0,
    addressIdStore: 0,
    address: "",
    postalCode: "",

    hotelName: "",
    modalErrors: {
      employeeNumber: "",
      airportCode: "",
      airlineCode: "",
      latitude: "",
      longitude: "",
      address: "",
      postalCode: "",
    },
  });
  const GetDropdownAirportDataSource = async () => {
    try {
      const requestParams = getRequestParams("GET", null);
      let url = `${
        process.env.REACT_APP_API_BASE_URL
      }Airport/get-airport-dropdown/${sessionStorage.getItem(
        "session_airlineCode"
      )}`;
      const airportDropdownData = await fetch(url, requestParams).then(
        (response) => response.json()
      );
      setState((prev) => ({
        ...prev,
        dropdownAirportDataSource: airportDropdownData?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const isValid = () => {
    let isValid = true;
    try {
      let err = state.modalErrors;
      err.airportCode = "";
      err.latitude = "";
      err.longitude = "";
      err.postalCode = "";
      err.address = "";
      if (!state.airportCode) {
        isValid = false;
        err.airportCode = "Please select airport code";
      }
      if (!state.latitude) {
        isValid = false;
        err.latitude = "Please enter latitude";
      }
      if (!state.longitude) {
        isValid = false;
        err.longitude = "Please enter longitude";
      }
      if (!state.postalCode) {
        isValid = false;
        err.postalCode = "Please enter postal code";
      }
      if (!state.address) {
        isValid = false;
        err.address = "Please enter address";
      }
      setState((prev) => ({ ...prev, modalErrors: err }));
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };
  const handleOnChangeStayLocation = async (e) => {
    e.preventDefault();
    try {
      if (isValid()) {
        let request = {};
        request.AirlineCode = state.airlineCode;
        request.AirportCode = state.airportCode;
        request.EmployeeNumber = state.employeeNumber;
        request.CzReservationId = state.reservationId;
        request.IsHotelCancel = state.isHotelCancel;
        request.TransporterRequired = state.isTransporterRequired;
        request.AddressId = state.addressId;
        request.AddressInfo = state.address;
        request.PostalCode = state.postalCode;
        request.Latitude = state.latitude;
        request.Longitude = state.longitude;
        request.DeviceTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        setState((prev) => ({ ...prev, isSubmitted: true }));
        let res = await fetch(
          process.env.REACT_APP_API_BASE_URL +
            "CrewActivity/change-stay-location",
          getRequestParams("POST", request)
        );
        const data = await res.json();
        setState((prev) => ({ ...prev, isSubmitted: false }));
        if (data.isSuccess) {
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            allowOutsideClick: false,
          }).then(async (result) => {
            if (result.isConfirmed) {
              await props.onRefresh();
            }
          });
        } else {
          toast.error(data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            closeButton: false,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getCrewAddressList = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      var request = {};
      request.AirlineCode = airlineCode;
      request.EmployeeNo = state.employeeNumber;
      const requestParams = getRequestParams("POST", request);
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}Crew/get-address`,
        requestParams
      );
      const data = await response.json();
      const filteredData = data.filter(
        (f) => f.baseStation === state.airportCode
      );
      setState((prev) => ({
        ...prev,
        crewAdderssDropdownDataSource: filteredData ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const handelOnAddressChange = (e) => {
    try {
      let err = state.modalErrors;
      err.address = "";
      err.postalCode = "";
      err.latitude = "";
      err.longitude = "";
      let addressId = e.selectedItem.rowIndex ?? 0;
      setState((prev) => ({
        ...prev,
        addressId: addressId,
        addressIdStore: addressId,
        address:
          state.crewAddressDataGridSource.filter(
            (f) => f.rowIndex === addressId ?? 0
          )[0]?.address ?? "",
        postalCode:
          state.crewAddressDataGridSource.filter(
            (f) => f.rowIndex === addressId ?? 0
          )[0]?.postalCode ?? "",
        latitude:
          state.crewAddressDataGridSource.filter(
            (f) => f.rowIndex === addressId ?? 0
          )[0]?.latitude ?? "",
        longitude:
          state.crewAddressDataGridSource.filter(
            (f) => f.rowIndex === addressId ?? 0
          )[0]?.longitude ?? "",
      }));
      setState((prev) => ({
        ...prev,
        modalErrors: err,
      }));
    } catch (error) {}
  };
  const handleOnCloseAddressPopupModal = (isWithAddress) => {
    if (isWithAddress === false) {
      setState((prev) => ({
        ...prev,
        addressIdStore: 0,
      }));
    }
  };
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        onAfterOpen={async () => {
          await GetDropdownAirportDataSource();
          await getCrewAddressList();
        }}
        onAfterClose={() => {
          setState((prev) => ({
            ...prev,
            employeeNumber: "",
            airlineCode: "",
            airportCode: "",
            latitude: "",
            longitude: "",
            reservationId: 0,
            addressId: 0,
            addressIdStore: 0,
            address: "",
            postalCode: "",
            isHotelCancel: false,
            isTransporterRequired: false,
            hotelName: "",
            modalErrors: {
              employeeNumber: "",
              airportCode: "",
              airlineCode: "",
              latitude: "",
              longitude: "",
              address: "",
              postalCode: "",
            },
          }));
        }}
        style={{ content: { width: "50%" } }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            Change / Cancel Hotel - {state.hotelName}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Employee Number<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Select Employee"
                  name="employeeNumber"
                  value={state.employeeNumber}
                  readOnly={true}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Airline Code<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Airline Code"
                  name="airlineCode"
                  value={state.airlineCode}
                  readOnly={true}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Airport Code<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={state.dropdownAirportDataSource}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Airport"
                  name="airportCode"
                  value={state.airportCode}
                  defaultValue={state.airportCode}
                  displayExpr="airportCode"
                  valueExpr="airportCode"
                  readOnly={true}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                />
                {state.modalErrors.airportCode.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.modalErrors.airportCode}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Latitude<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="latitude"
                  title="latitude"
                  placeholder="Enter latitude"
                  value={state.latitude}
                  onValueChanged={(value) => {
                    if (value.trim() === "" || RegEx.LatLong.test(value)) {
                      setState((prev) => ({ ...prev, latitude: value }));
                    }
                  }}
                />
                {state.modalErrors.latitude?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.modalErrors.latitude}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Longitude<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="longitude"
                  title="longitude"
                  placeholder="Enter longitude"
                  value={state.longitude}
                  onValueChanged={(value) => {
                    if (value.trim() === "" || RegEx.LatLong.test(value)) {
                      setState((prev) => ({ ...prev, longitude: value }));
                    }
                  }}
                />
                {state.modalErrors.longitude?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.modalErrors.longitude}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Postal Code<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="postalCode"
                  title="postalCode"
                  placeholder="Enter postal code"
                  value={state.postalCode}
                  onValueChanged={(value) => {
                    if (value.trim() === "" || value.length <= 7) {
                      setState((prev) => ({ ...prev, postalCode: value }));
                    }
                  }}
                />
                {state.modalErrors.postalCode.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.modalErrors.postalCode}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-8 col-md-8">
              <div className="form-group">
                <label>
                  Address<span className="text-danger">*</span>
                </label>
                <span
                  className="float-right"
                  style={{
                    cursor: "pointer",
                    color: "blue",
                    fontSize: "11px",
                  }}
                  onClick={async (e) => {
                    try {
                      setState((prev) => ({
                        ...prev,
                        isOpenSelectAddressModal: true,
                      }));
                      await getCrewAddressList();
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  [Select Address]
                </span>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="address"
                  title="address"
                  placeholder="Enter address"
                  value={state.address}
                  onVolumeChange={(value) => {
                    if (value.trim() === "" || value.length <= 250) {
                      setState((prev) => ({ ...prev, address: value }));
                    }
                  }}
                />
                {state.modalErrors.address?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.modalErrors.address}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-2 col-md-2">
              <div className="form-group">
                <label htmlFor="isHotelCancel"> Cancel Hotel</label>
                <br />
                <CheckBox
                  id="isHotelCancel"
                  name="isHotelCancel"
                  value={state.isHotelCancel}
                  onValueChanged={(e) => {
                    let cancelHotel = state.isHotelCancel;
                    cancelHotel = e.value;
                    setState((prev) => ({
                      ...prev,
                      isHotelCancel: cancelHotel,
                    }));
                  }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-2">
              <div className="form-group">
                <label htmlFor="isTransporterRequired">
                  Transporter Required
                </label>
                <br />
                <CheckBox
                  id="isTransporterRequired"
                  name="Transporter Required"
                  value={state.isTransporterRequired}
                  onValueChanged={(e) => {
                    let isTransporterRequired = state.isTransporterRequired;
                    isTransporterRequired = e.value;
                    setState((prev) => ({
                      ...prev,
                      isTransporterRequired: isTransporterRequired,
                    }));
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Save"
            className="btn btn-success"
            onClick={async (e) => {
              await handleOnChangeStayLocation(e);
            }}
          >
            <i
              className={`fas fa-${
                state.isSubmitted ? "spinner fa-spin" : "check"
              }`}
            />
            &nbsp;&nbsp;Change
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            title="Cancel"
            className="btn btn-custom-gray"
            onClick={() => {
              props.onClose();
            }}
          >
            <span title="Reset">
              <i className="fas fa-times"></i>&nbsp; Close
            </span>
          </button>
        </div>
      </Modal>
      {state.isOpenSelectAddressModal && (
        <ShowSelectAddressModal
          airportCode={state.airportCode}
          crewAdderssDropdownDataSource={state.crewAdderssDropdownDataSource}
          addressIdStore={state.addressIdStore}
          handelOnAddressChange={(e) => {
            handelOnAddressChange(e);
          }}
          Close={(isWithAddress) => {
            handleOnCloseAddressPopupModal(isWithAddress);
          }}
        />
      )}
    </>
  );
}
function ShowSelectAddressModal(props) {
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "30%" } }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            Select Address - [{props.airportCode}]
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.Close(false);
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="form-group">
                <label>
                  Address
                  <span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={props.crewAdderssDropdownDataSource}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Address"
                  name="address"
                  value={props.addressIdStore}
                  displayExpr="address"
                  valueExpr="rowIndex"
                  onSelectionChanged={(e) => {
                    props.handelOnAddressChange(e);
                  }}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Save"
            className="btn btn-success"
            onClick={() => {
              props.Close(true);
            }}
          >
            &nbsp;&nbsp;Select
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            title="Cancel"
            className="btn btn-custom-gray"
            onClick={() => {
              props.Close(false);
            }}
          >
            <span title="Reset">
              <i className="fas fa-times"></i>&nbsp; Close
            </span>
          </button>
        </div>
      </Modal>
    </>
  );
}
function ChangeHotelModal(props) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [hotelId, setHotelId] = useState(props?.activityData?.hotelId ?? 0);
  const [hotelDropdown, setHotelDropdown] = useState([]);
  const [errors, setErrors] = useState({
    hotelValidation: "",
  });

  const getHotelDropdown = async () => {
    try {
      const response = await axiosPost(`CrewActivity/allocate-hotel-dropdown`, {
        AirlineCode: props?.activityData?.airlineCode,
        TransactionId: props?.activityData?.transactionId,
        EmployeeNumber: props?.activityData?.employeeNumber,
        AirportCode: props?.activityData?.airportCode,
        LocationCode: props?.activityData?.activityLocationCode,
      });
      setHotelDropdown(response?.payload ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.hotelValidation = "";
      if (hotelId === 0) {
        isValid = false;
        err.hotelValidation = "Please select hotel";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnChangeHotel = async (e) => {
    e.preventDefault();
    try {
      if (isValidData()) {
        let confirmationQuestion = `Are You Sure Want To Change Hotel For ${props.activityData?.firstName} ${props.activityData?.lastName}?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setIsSubmitted(true);
        const response = await axiosPost(`CrewActivity/change-hotel`, {
          AirlineCode: props?.activityData?.airlineCode,
          TransactionId: props?.activityData?.transactionId,
          EmployeeNumber: props?.activityData?.employeeNumber,
          HotelId: hotelId,
          DeviceTime: moment(new Date()).format(
            DateFormat.SqlDateTimeFullFormat
          ),
        });
        isConfirmed = await showResponseMessage(response);
        setIsSubmitted(false);
        if (isConfirmed) {
          if (response?.isSuccess) {
            props.onClose();
            setHotelDropdown([]);
            setHotelId(0);
            setIsSubmitted(false);
            props.onRefresh();
          }
        }
      }
    } catch (error) {
      setIsSubmitted(false);
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-medium"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        onAfterOpen={async () => {
          let err = { ...errors };
          err.hotelValidation = "";
          setErrors(err);
          await getHotelDropdown();
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            Change Hotel&nbsp;For&nbsp;{props?.activityData?.firstName}&nbsp;
            {props?.activityData?.lastName}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.onClose();
              setHotelDropdown([]);
              setHotelId(0);
              setIsSubmitted(false);
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="form-group">
                <label>
                  Hotel&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={hotelDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Hotel"
                  name="hotelDropdown"
                  defaultValue={hotelId}
                  value={hotelId}
                  displayExpr="name"
                  valueExpr="id"
                  showClearButton={true}
                  searchEnabled={true}
                  disabled={false}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.hotelValidation = "";
                    setErrors(err);
                    setHotelId(e?.selectedItem?.id ?? 0);
                  }}
                />
                {errors.hotelValidation.length > 0 && (
                  <span className="error invalid-feedback">
                    {errors.hotelValidation}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Submit"
            className="btn btn-primary"
            onClick={async (e) => {
              await handleOnChangeHotel(e);
            }}
            disabled={isSubmitted}
          >
            <i
              className={`fas fa-${isSubmitted ? "spinner fa-spin" : "check"}`}
            />
            &nbsp;&nbsp;Submit
          </button>
          <button
            type="button"
            title="Close"
            className="btn btn-secondary"
            onClick={() => {
              props.onClose();
              setHotelDropdown([]);
              setHotelId(0);
              setIsSubmitted(false);
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}
